import script from "./RadioInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioInput.vue?vue&type=script&setup=true&lang=js"

import "./RadioInput.vue?vue&type=style&index=0&id=547ae5d7&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547ae5d7"]])

export default __exports__